// extracted by mini-css-extract-plugin
export var KAcard = "index-module--KAcard--Uojmi";
export var KAcardClick = "index-module--KAcardClick--2YeVL";
export var KApartners = "index-module--KApartners--7NuBj";
export var backgroundContainer = "index-module--backgroundContainer--p1JzW";
export var container = "index-module--container--QnfSj";
export var descriptionContainer = "index-module--descriptionContainer--TysJu";
export var footer = "index-module--footer--uUe4E";
export var frontContainer = "index-module--frontContainer--z34NT";
export var header = "index-module--header--4dhJ-";
export var headerBigTop = "index-module--headerBigTop--NIviO";
export var logoContainer = "index-module--logoContainer--3HH9J";
export var title = "index-module--title--zZhaN";